<template>
  <div style="text-align: center">
    <h3 class="kaihu">账号开户</h3>
    <step :active="2"></step>
    <div v-if="type == 1">
      <img src="@/assets/rengongshenhezhong.png" />
      <br />
      <b>银行开户审核中</b>
      <div style="color:#B4CFFF;margin-top:48px;">
        您的开户信息已提交至银行，请您耐心等待银行开户结果
      </div>
      <el-button type="primary" @click="backToHome" style="margin-top:74px;">
        返回首页
      </el-button>
    </div>
    <div v-else>
      <img src="@/assets/zhifushenheshibai.png" />
      <br />
      <b>银行开户审核失败</b>
      <div style="color:#B4CFFF;margin-top:48px;">
        请联系运营人员进行人工指导
      </div>
      <el-button type="primary" @click="toStep1" style="margin-top:74px;">
        重新输入
      </el-button>
    </div>
  </div>
</template>
<script>
import step from './step.vue';
export default {
  props: {
    reason: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1 //1是成功 2是失败
    }
  },
  data() {
    return {};
  },
  components: {
    step
  },
  methods: {
    backToHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toStep1() {
      this.$parent.currentCom = 'step1';
    }
  }
};
</script>
<style lang="scss" scoped></style>
